import React from 'react';
import Plot from 'react-plotly.js';

const VectorField = ({ data, title = 'Vector Field' }) => {
  if (!data || !data.x || !data.y || !data.u || !data.v) {
    return <div className="plot-error">Invalid vector field data</div>;
  }

  // Create meshgrid for vector field
  const plotData = [{
    x: data.x,
    y: data.y,
    u: data.u,
    v: data.v,
    type: 'scatter',
    mode: 'markers',
    marker: {
      symbol: 'arrow',
      size: 8,
      color: '#2563eb',
      line: { width: 1, color: '#1e40af' }
    },
    name: 'Vector Field'
  }];

  // Add quiver plot using annotations
  const annotations = [];
  for (let i = 0; i < data.x.length; i++) {
    const magnitude = Math.sqrt(data.u[i] * data.u[i] + data.v[i] * data.v[i]);
    const scale = 0.1; // Adjust arrow scale
    
    annotations.push({
      x: data.x[i],
      y: data.y[i],
      ax: data.x[i] + data.u[i] * scale,
      ay: data.y[i] + data.v[i] * scale,
      xref: 'x',
      yref: 'y',
      axref: 'x',
      ayref: 'y',
      showarrow: true,
      arrowhead: 2,
      arrowsize: 1,
      arrowwidth: 2,
      arrowcolor: '#2563eb'
    });
  }

  const layout = {
    title: {
      text: title,
      font: { size: 16, family: 'Arial, sans-serif' }
    },
    xaxis: {
      title: data.variables?.[0] || 'x',
      gridcolor: '#e5e7eb',
      zerolinecolor: '#9ca3af'
    },
    yaxis: {
      title: data.variables?.[1] || 'y',
      gridcolor: '#e5e7eb',
      zerolinecolor: '#9ca3af'
    },
    plot_bgcolor: '#ffffff',
    paper_bgcolor: '#ffffff',
    margin: { l: 60, r: 30, t: 60, b: 60 },
    showlegend: false,
    annotations: annotations
  };

  const config = {
    displayModeBar: true,
    displaylogo: false,
    modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d'],
    responsive: true
  };

  return (
    <div className="plot-container" style={{ width: '100%', height: '400px' }}>
      <Plot
        data={[]} // Empty data since we're using annotations
        layout={layout}
        config={config}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default VectorField;